export default "__VITE_ASSET__b7ebc6f4__"